<template>
  <svg
    class="custom-icon"
    width="6"
    height="14"
    viewBox="0 0 6 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.46806 11.965C5.84037 11.6386 5.57141 11.0879 5.03968 11.0879H0.8038C0.27572 11.0879 0.00518639 11.6321 0.370128 11.9603L2.46119 13.8406C2.69541 14.0513 3.08591 14.0534 3.32323 13.8453L5.46806 11.965Z"
    />
    <path
      d="M0.400732 2.04198C0.0284204 2.36838 0.297377 2.91906 0.829107 2.91906H5.15958C5.69297 2.91906 5.96119 2.36543 5.58553 2.03986L3.40782 0.152549C3.17217 -0.0516754 2.78777 -0.0507233 2.55349 0.154665L0.400732 2.04198Z"
    />
    <path
      d="M0 7.00348C0 6.43366 0.537258 5.97173 1.2 5.97173H4.8C5.46274 5.97173 6 6.43366 6 7.00348C6 7.57329 5.46274 8.03522 4.8 8.03522H1.2C0.537258 8.03522 0 7.57329 0 7.00348Z"
    />
  </svg>
</template>
